// ============================================================
//  CART RESERVATION — 5-min hold, cohort switch, back trap
// ============================================================
(function () {
  "use strict";

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function boot() {
    // ── FEATURE TOGGLE — theme setting controls everything ──
    if (window.apartmentCartReserveEnabled === false) {
      console.log("[reserve] disabled by theme setting — holds off");
      return;
    }

    var form = document.getElementById("product-form");
    if (!form || !window.apartmentVariants) return;

    var BACKEND = (window.apartmentBackendUrl || "").replace(/\/+$/, "");
    var PRODUCT_ID = String(window.apartmentProductId || "");
    if (!BACKEND || !PRODUCT_ID) {
      console.warn(
        "[reserve] backend URL or product ID missing — holds disabled",
      );
      return;
    }

    // ── TTLs FROM THEME SETTINGS (fallback to defaults) ─────
    var DEFAULT_TTL_MIN = Number(window.apartmentReserveTtl) || 5;
    var CHECKOUT_TTL_MIN = Number(window.apartmentReserveCheckoutTtl) || 15;

    var state = {
      ref: null,
      slotKey: null,
      expiresAt: null,
      released: false,
      queue: Promise.resolve(),
      timerInterval: null,
      expiryTimeout: null, // ← NEW
    };

    // Guards against installing the back trap more than once — without
    // this, every successful hold would add another history entry and
    // another popstate listener, causing stacked modals and back-button
    // traps.
    var backTrapInstalled = false;

    // ── Owned-hold persistence ─────────────────────────────
    // When we hand the customer off to checkout, we save the
    // reservation ref so that if they navigate back to the
    // apartment page before the hold expires, we can resume it
    // instead of getting a 409 against our own reservation.
    var RESERVATION_STORAGE_PREFIX = "apartment_reservation_v1";

    function getReservationStorageKey() {
      return RESERVATION_STORAGE_PREFIX + ":" + PRODUCT_ID;
    }

    function saveReservationRef(ref, slotKey) {
      try {
        localStorage.setItem(
          getReservationStorageKey(),
          JSON.stringify({ ref: ref, slotKey: slotKey, ts: Date.now() }),
        );
      } catch (_) {}
    }

    function loadReservationRef() {
      try {
        var raw = localStorage.getItem(getReservationStorageKey());
        if (!raw) return null;
        var obj = JSON.parse(raw);
        if (!obj || !obj.ref) return null;
        // Ignore anything older than 1 hour
        if (obj.ts && Date.now() - obj.ts > 60 * 60 * 1000) {
          localStorage.removeItem(getReservationStorageKey());
          return null;
        }
        return obj;
      } catch (_) {
        return null;
      }
    }

    function clearReservationRef() {
      try {
        localStorage.removeItem(getReservationStorageKey());
      } catch (_) {}
    }

    // ── helpers ──────────────────────────────────────────────
    function getVariantId() {
      var el = document.getElementById("selected-variant-id");
      return el ? String(el.value) : null;
    }
    // ── book-button gate ─────────────────────────────────────
    // When the currently-shown variant is held by another customer,
    // or our own hold has expired, we disable the submit button so
    // the customer can't push a doomed form to Shopify. The button
    // is re-enabled the moment a valid hold exists.
    function setBookButtonState(disabled, reason) {
      var btn = document.getElementById("add-to-cart-btn");
      if (!btn) return;

      if (disabled) {
        btn.setAttribute("data-reserve-disabled", "1");
        btn.disabled = true;
        btn.style.opacity = "0.5";
        btn.style.cursor = "not-allowed";
        btn.setAttribute("aria-disabled", "true");
        if (reason) btn.title = reason;
      } else {
        btn.removeAttribute("data-reserve-disabled");
        btn.disabled = false;
        btn.style.opacity = "";
        btn.style.cursor = "";
        btn.removeAttribute("aria-disabled");
        btn.removeAttribute("title");
      }
    }
    function slotKeyFor(variantId) {
      return PRODUCT_ID + ":" + String(variantId);
    }

    function shopCurrency() {
      var c =
        (window.Shopify &&
          window.Shopify.currency &&
          window.Shopify.currency.active) ||
        (form.dataset && form.dataset.shopCurrency) ||
        "EUR";
      return String(c).toLowerCase();
    }

    function grandTotalCents() {
      var vid = getVariantId();
      var v = (window.apartmentVariants || []).find(function (x) {
        return String(x.id) === vid;
      });
      var apt = v ? Number(v.price) || 0 : 0;
      var fees = 0;
      document
        .querySelectorAll("[data-calculator-input][data-unit-price]")
        .forEach(function (el) {
          var q = Number(el.value) || 0;
          var p = Number(el.getAttribute("data-unit-price")) || 0;
          fees += q * p * 100;
        });
      return apt + fees;
    }

    function parseExpiresAt(v) {
      if (!v) return null;
      if (typeof v === "number") return v;
      var t = Date.parse(v);
      return Number.isFinite(t) ? t : null;
    }

    function applyReservation(d) {
      if (!d || !d.reservation) return;
      state.ref = d.reservation.reservationRef;
      state.slotKey = d.reservation.slotKey;
      state.expiresAt = parseExpiresAt(d.reservation.expiresAt);
      renderHoldTimer();
    }

    // ── backend calls ────────────────────────────────────────
    function createHold(slotKey) {
      return fetch(BACKEND + "/api/cart/reserve", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          slotKey: slotKey,
          currency: shopCurrency(),
          totalAmount: grandTotalCents(),
          ttlMinutes: DEFAULT_TTL_MIN,
        }),
      }).then(function (r) {
        if (r.status === 409) return { ok: false, reason: "SLOT_TAKEN" };
        if (!r.ok) return { ok: false, reason: "ERROR" };
        return r.json().then(function (d) {
          applyReservation(d);
          return { ok: true };
        });
      });
    }

    function switchHold(newSlotKey) {
      if (!state.ref) return createHold(newSlotKey);
      return fetch(
        BACKEND +
          "/api/cart/reserve/" +
          encodeURIComponent(state.ref) +
          "/switch",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ slotKey: newSlotKey }),
        },
      ).then(function (r) {
        if (r.status === 409) return { ok: false, reason: "SLOT_TAKEN" };
        if (r.status === 410) {
          state.ref = null;
          return createHold(newSlotKey);
        }
        if (!r.ok) return { ok: false, reason: "ERROR" };
        return r.json().then(function (d) {
          applyReservation(d);
          return { ok: true };
        });
      });
    }

    function extendHold(ttlMinutes) {
      if (!state.ref) return Promise.resolve({ ok: false });
      return fetch(
        BACKEND +
          "/api/cart/reserve/" +
          encodeURIComponent(state.ref) +
          "/extend",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ttlMinutes: ttlMinutes }),
        },
      )
        .then(function (r) {
          if (r.status === 404 || r.status === 410)
            return { ok: false, reason: "GONE" };
          if (!r.ok) return { ok: false, reason: "ERROR" };
          return r.json().then(function (d) {
            applyReservation(d);
            return { ok: true };
          });
        })
        .catch(function () {
          return { ok: false, reason: "NETWORK" };
        });
    }

    function releaseHold() {
      if (state.ref) {
        var url =
          BACKEND + "/api/cart/reserve/" + encodeURIComponent(state.ref);
        try {
          fetch(url, { method: "DELETE", keepalive: true });
        } catch (_) {}
      }
      state.ref = null;
      state.expiresAt = null;
      clearReservationRef(); // ← NEW
      stopHoldTimer();
    }

       // ── page-load hold ───────────────────────────────────────
    function startInitialHold() {
      var vid = getVariantId();
      var saved = loadReservationRef();

      // ── Step 1: try to resume a previously-saved hold ─────
      // IMPORTANT: this runs regardless of whether the variant
      // is set yet. The variant input may not be populated until
      // restoreApartmentFormState() completes (race on page load).
      if (saved && saved.ref && saved.slotKey) {
        state.ref = saved.ref;
        state.slotKey = saved.slotKey;

        extendHold(DEFAULT_TTL_MIN).then(function (r) {
          if (r.ok) {
            setBookButtonState(false);
            renderHoldTimer();
            installBackTrap();
            return;
          }

          if (r.reason === "NETWORK") {
            // Backend unreachable — don't clear the saved ref.
            notifyUnavailable(
              "Could not verify your hold. Please refresh the page.",
            );
            return;
          }

          // GONE or ERROR — safe to clear and try fresh
          clearReservationRef();
          state.ref = null;
          state.slotKey = null;
          var nowVid = getVariantId();
          if (nowVid) createFreshHold(nowVid, slotKeyFor(nowVid));
        });
        return;
      }

      // ── Step 2: no saved hold — create one ────────────────
      if (!vid) return;
      createFreshHold(vid, slotKeyFor(vid));
    }

    function createFreshHold(vid, slotKey) {
      createHold(slotKey).then(function (res) {
        if (res.ok) {
          setBookButtonState(false);
          renderHoldTimer();
          installBackTrap();
          return;
        }
        if (res.reason === "SLOT_TAKEN") {
          var fallback = (window.apartmentVariants || []).find(function (v) {
            return v.available && String(v.id) !== vid;
          });
          if (!fallback) {
            setBookButtonState(
              true,
              "This apartment is currently held by another customer.",
            );
            notifyUnavailable(
              "This apartment is currently held by another customer. Please try again in a few minutes.",
            );
            return;
          }
          state.slotKey = slotKeyFor(fallback.id);

          var $opt = window.jQuery
            ? window.jQuery(
                '.custom_dropdown_option[data-variant-id="' +
                  fallback.id +
                  '"]',
              )
            : null;
          if ($opt && $opt.length) {
            $opt.trigger("click");
          } else {
            document.getElementById("selected-variant-id").value = String(
              fallback.id,
            );
          }
          createHold(slotKeyFor(fallback.id)).then(function (r2) {
            if (r2.ok) {
              setBookButtonState(false);
              installBackTrap();
            } else {
              setBookButtonState(
                true,
                "This apartment is currently unavailable.",
              );
              notifyUnavailable("This apartment is currently unavailable.");
            }
          });
        }
        if (res.reason === "ERROR") {
          setBookButtonState(
            true,
            "Could not verify availability. Please try again.",
          );
        }
      });
    }

    // ── cohort switch ────────────────────────────────────────
    function onVariantChanged(newVid) {
      if (state.released) return;

      // No variant picked yet — the main JS validator handles this.
      // Make sure the button isn't stuck from a previous state.
      if (!newVid) {
        setBookButtonState(false);
        return;
      }

      var newSlotKey = slotKeyFor(newVid);

      // User reverted to the variant we already hold → make sure the
      // button is re-enabled (they may have just bounced off a held date).
      if (newSlotKey === state.slotKey) {
        setBookButtonState(false);
        return;
      }

      state.queue = state.queue.then(function () {
        return switchHold(newSlotKey).then(function (res) {
          if (res.ok) {
            setBookButtonState(false);
            installBackTrap();
            return;
          }

          if (res.reason === "SLOT_TAKEN") {
            setBookButtonState(
              true,
              "That date is currently held by another customer.",
            );
            notifyUnavailable(
              "That date is currently held by another customer. Please pick another.",
            );

            // Revert the dropdown to the variant we hold. That triggers
            // onVariantChanged(prevVid), which re-enables the button.
            if (state.slotKey) {
              var prevVid = state.slotKey.split(":")[1];
              var $prev = window.jQuery
                ? window.jQuery(
                    '.custom_dropdown_option[data-variant-id="' +
                      prevVid +
                      '"]',
                  )
                : null;
              if ($prev && $prev.length) $prev.trigger("click");
            }
            return;
          }

          if (res.reason === "ERROR") {
            setBookButtonState(
              true,
              "Could not verify availability. Please try again.",
            );
          }
        });
      });
    }

    var optionsList = document.getElementById("variant-options-list");
    var lastSeenVid = getVariantId();

    if (optionsList) {
      optionsList.addEventListener("click", function (e) {
        var option =
          e.target.closest && e.target.closest(".custom_dropdown_option");
        if (!option) return;
        var newVid = option.getAttribute("data-variant-id");
        if (!newVid) return;
        lastSeenVid = newVid;
        setTimeout(function () {
          onVariantChanged(newVid);
        }, 0);
      });
    }

    setInterval(function () {
      var vid = getVariantId();
      if (vid && vid !== lastSeenVid) {
        lastSeenVid = vid;
        onVariantChanged(vid);
      }
    }, 500);

    // ── submit hand-off ──────────────────────────────────────
    // form.addEventListener(
    //   "submit",
    //   function () {
    //     if (state.released) return;
    //     injectAttributes({
    //       reservation_ref: state.ref || "",
    //       slot_key: state.slotKey || "",
    //       payment_plan: "deposit_30",
    //       booking_total: (grandTotalCents() / 100).toFixed(2),
    //     });
    //     extendHold(CHECKOUT_TTL_MIN).catch(function () {});
    //     state.released = true;
    //   },
    //   true
    // );
    form.addEventListener(
      "submit",
      function (e) {
        if (state.released) return;

        // ── Refuse submit if the button was disabled by the reserve gate.
        // This catches the "Enter key in a text field" path which fires a
        // submit event even when the only submit button is disabled.
        if (e.target === form) {
          var submitter = e.submitter || null;
          var btn = document.getElementById("add-to-cart-btn");
          if (btn && btn.getAttribute("data-reserve-disabled") === "1") {
            // Check whether the submitter is something else (e.g. a link)
            // — if the form is submitting itself or via the disabled button,
            // block it.
            if (!submitter || submitter === btn) {
              e.preventDefault();
              e.stopImmediatePropagation();
              return;
            }
          }
        }
        // ── Guarantee the submitted variant == the reserved variant ──
        // If the dropdown drifted (failed switch, backend error, stale
        // revert), we force it back to the slot we actually hold so the
        // customer can never be charged for a variant nobody reserved.
        if (state.slotKey) {
          var heldVid = String(state.slotKey).split(":")[1];
          var variantInput = document.getElementById("selected-variant-id");
          if (
            heldVid &&
            variantInput &&
            String(variantInput.value) !== heldVid
          ) {
            console.warn(
              "[reserve] variant drift detected — forcing form back to held variant",
              { form: variantInput.value, held: heldVid },
            );
            variantInput.value = heldVid;

            // Also re-sync the visible label so the UI matches what we submit
            var $opt = window.jQuery
              ? window.jQuery(
                  '.custom_dropdown_option[data-variant-id="' + heldVid + '"]',
                )
              : null;
            if ($opt && $opt.length) {
              var label = $opt.text().trim();
              var $label = document.getElementById("selected-variant-label");
              if ($label) {
                $label.textContent = label;
                $label.classList.remove("placeholder_active");
              }
            }
          }
        }

        injectAttributes({
          reservation_ref: state.ref || "",
          slot_key: state.slotKey || "",
          payment_plan: "deposit_30",
          booking_total: (grandTotalCents() / 100).toFixed(2),
        });

        // Persist the ref so a return to the apartment page resumes
        // this hold instead of getting a 409 against our own slot.
        if (state.ref) saveReservationRef(state.ref, state.slotKey);

        extendHold(CHECKOUT_TTL_MIN).catch(function () {});
        state.released = true;
      },
      true,
    );
    function injectAttributes(map) {
      form
        .querySelectorAll("input[data-reservation-attr]")
        .forEach(function (el) {
          el.remove();
        });
      Object.keys(map).forEach(function (k) {
        var v = map[k];
        if (v === undefined || v === null || v === "") return;
        var inp = document.createElement("input");
        inp.type = "hidden";
        inp.name = "attributes[" + k + "]";
        inp.value = String(v);
        inp.setAttribute("data-reservation-attr", "1");
        form.appendChild(inp);
      });
    }

    // ── back trap + leave modal ──────────────────────────────
    function installBackTrap() {
      if (backTrapInstalled) return;
      backTrapInstalled = true;

      history.pushState({ apartmentHold: true }, "", location.href);

      window.addEventListener("popstate", function () {
        if (state.released) return;
        showLeaveModal(function (goBack) {
          if (goBack) {
            state.released = true;
            releaseHold();
            history.back();
          } else {
            history.pushState({ apartmentHold: true }, "", location.href);
          }
        });
      });

      document.addEventListener(
        "click",
        function (e) {
          if (state.released) return;
          var a = e.target.closest && e.target.closest("a[href]");
          if (!a) return;
          if (a.hostname !== location.hostname) return;
          if (a.hasAttribute("data-skip-hold-trap")) return;

          var raw = a.getAttribute("href") || "";
          if (!raw || raw === "#" || raw.indexOf("javascript:") === 0) return;

          var target, current;
          try {
            target = new URL(a.href, location.href);
            current = new URL(location.href);
          } catch (_) {
            return;
          }
          if (
            target.origin === current.origin &&
            target.pathname === current.pathname &&
            target.search === current.search
          ) {
            return;
          }

          e.preventDefault();
          showLeaveModal(function (goBack) {
            if (goBack) {
              state.released = true;
              releaseHold();
              window.location.href = a.href;
            }
          });
        },
        true,
      );
    }

    // function installBackTrap() {
    //   history.pushState({ apartmentHold: true }, "", location.href);

    //   window.addEventListener("popstate", function () {
    //     if (state.released) return;
    //     showLeaveModal(function (goBack) {
    //       if (goBack) {
    //         state.released = true;
    //         releaseHold();
    //         history.back();
    //       } else {
    //         history.pushState({ apartmentHold: true }, "", location.href);
    //       }
    //     });
    //   });

    //   document.addEventListener(
    //     "click",
    //     function (e) {
    //       if (state.released) return;
    //       var a = e.target.closest && e.target.closest("a[href]");
    //       if (!a) return;
    //       if (a.hostname !== location.hostname) return;
    //       if (a.hasAttribute("data-skip-hold-trap")) return;

    //       var raw = a.getAttribute("href") || "";
    //       if (!raw || raw === "#" || raw.indexOf("javascript:") === 0) return;

    //       var target, current;
    //       try {
    //         target = new URL(a.href, location.href);
    //         current = new URL(location.href);
    //       } catch (_) {
    //         return;
    //       }
    //       if (
    //         target.origin === current.origin &&
    //         target.pathname === current.pathname &&
    //         target.search === current.search
    //       ) {
    //         return;
    //       }

    //       e.preventDefault();
    //       showLeaveModal(function (goBack) {
    //         if (goBack) {
    //           state.released = true;
    //           releaseHold();
    //           window.location.href = a.href;
    //         }
    //       });
    //     },
    //     true
    //   );
    // }

    // ── theme-editable leave modal ───────────────────────────
    var modalEl = null;
    var modalAnswerHandler = null;

    function showLeaveModal(onAnswer) {
      var cfg = window.apartmentReservePopup || {};

      // If popup disabled by theme setting → treat as "leave" immediately
      if (cfg.enabled === false) {
        onAnswer(true);
        return;
      }

      var heading = cfg.heading || "Leave this apartment?";
      var bodyText =
        cfg.body || "If you go back, the apartment will no longer be reserved.";
      var stayLabel = cfg.stayLabel || "Stay here";
      var leaveLabel = cfg.leaveLabel || "Go back";
      var c = cfg.colors || {};
      var radius = cfg.radius != null ? cfg.radius : 12;

      var bg = c.bg || "#ffffff";
      var headingColor = c.heading || "#111111";
      var bodyColor = c.body || "#444444";
      var stayBg = c.stayBg || "#ffffff";
      var stayText = c.stayText || "#111111";
      var leaveBg = c.leaveBg || "#111111";
      var leaveText = c.leaveText || "#ffffff";

      if (!modalEl) {
        modalEl = document.createElement("div");
        modalEl.setAttribute("data-apartment-leave-modal", "1");
        document.body.appendChild(modalEl);
      }

      modalEl.innerHTML = [
        '<div style="position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:99998;display:flex;align-items:center;justify-content:center;padding:20px;">',
        '  <div style="background:' +
          bg +
          ";max-width:420px;width:100%;border-radius:" +
          radius +
          'px;padding:28px;text-align:center;font-family:inherit;box-shadow:0 12px 40px rgba(0,0,0,.25);">',
        '    <h3 style="margin:0 0 12px;font-size:1.15rem;color:' +
          headingColor +
          ';">' +
          escapeHtml(heading) +
          "</h3>",
        '    <p style="margin:0 0 22px;line-height:1.45;color:' +
          bodyColor +
          ';">' +
          escapeHtml(bodyText) +
          "</p>",
        '    <div style="display:flex;gap:10px;justify-content:center;">',
        '      <button type="button" data-answer="stay" style="padding:10px 18px;border-radius:8px;border:1px solid #ccc;background:' +
          stayBg +
          ";color:" +
          stayText +
          ';cursor:pointer;font:inherit;">' +
          escapeHtml(stayLabel) +
          "</button>",
        '      <button type="button" data-answer="leave" style="padding:10px 18px;border-radius:8px;border:0;background:' +
          leaveBg +
          ";color:" +
          leaveText +
          ';cursor:pointer;font:inherit;">' +
          escapeHtml(leaveLabel) +
          "</button>",
        "    </div>",
        "  </div>",
        "</div>",
      ].join("");

      modalEl.style.display = "block";

      if (modalAnswerHandler) {
        modalEl.removeEventListener("click", modalAnswerHandler, true);
      }

      modalAnswerHandler = function (e) {
        var btn = e.target.closest && e.target.closest("button[data-answer]");
        if (!btn) return;
        modalEl.style.display = "none";
        modalEl.removeEventListener("click", modalAnswerHandler, true);
        modalAnswerHandler = null;
        onAnswer(btn.getAttribute("data-answer") === "leave");
      };

      modalEl.addEventListener("click", modalAnswerHandler, true);
    }

    // ── toast helper ────────────────────────────────────────
    var toastEl = null;
    function notifyUnavailable(msg) {
      if (!toastEl) {
        toastEl = document.createElement("div");
        toastEl.style.cssText =
          "position:fixed;bottom:24px;left:50%;transform:translateX(-50%);" +
          "background:#111;color:#fff;padding:14px 22px;border-radius:10px;" +
          "z-index:99999;font:14px/1.4 inherit;max-width:90vw;text-align:center;" +
          "box-shadow:0 8px 30px rgba(0,0,0,.3);display:none;";
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = msg;
      toastEl.style.display = "block";
      clearTimeout(toastEl._t);
      toastEl._t = setTimeout(function () {
        toastEl.style.display = "none";
      }, 4500);
    }

    // ── hold countdown timer ────────────────────────────────
    var timerEl = null;

    function ensureTimerEl() {
      if (timerEl) return timerEl;
      timerEl = document.createElement("div");
      timerEl.setAttribute("data-hold-timer", "1");
      timerEl.style.cssText = [
        "position:fixed",
        "top:16px",
        "left:50%",
        "transform:translateX(-50%)",
        "background:#1E3A2F",
        "color:#F5F1E8",
        "padding:10px 18px",
        "border-radius:100px",
        "font-family:inherit",
        "font-size:11px",
        "letter-spacing:0.16em",
        "text-transform:uppercase",
        "z-index:99997",
        "box-shadow:0 6px 24px rgba(0,0,0,.18)",
        "display:none",
        "align-items:center",
        "gap:10px",
        "pointer-events:none",
        "user-select:none",
        "white-space:nowrap",
        "transition:background-color .35s ease",
      ].join(";");
      timerEl.innerHTML =
        '<span style="opacity:.72;">Apartment held</span>' +
        '<span data-hold-timer-value style="font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:14px;letter-spacing:0.05em;font-weight:600;text-transform:none;">--:--</span>';
      document.body.appendChild(timerEl);
      return timerEl;
    }

    function formatRemaining(ms) {
      if (ms < 0) ms = 0;
      var total = Math.floor(ms / 1000);
      var m = Math.floor(total / 60);
      var s = total % 60;
      return m + ":" + (s < 10 ? "0" : "") + s;
    }

    function stopHoldTimer() {
      if (state.expiryTimeout) {
        clearTimeout(state.expiryTimeout);
        state.expiryTimeout = null;
      }
      if (state.timerInterval) {
        clearInterval(state.timerInterval);
        state.timerInterval = null;
      }
      if (timerEl) timerEl.style.display = "none";
    }

    function renderHoldTimer() {
      if (state.expiryTimeout) {
        clearTimeout(state.expiryTimeout);
        state.expiryTimeout = null;
      }
      if (!state.expiresAt || state.released) {
        stopHoldTimer();
        return;
      }

      var el = ensureTimerEl();
      el.style.display = "inline-flex";

      var valEl = el.querySelector("[data-hold-timer-value]");
      var expired = false;

      function tick() {
        if (!state.expiresAt || state.released) {
          stopHoldTimer();
          return;
        }
        var remaining = state.expiresAt - Date.now();

        if (remaining <= 0) {
          if (expired) return;
          expired = true;
          valEl.textContent = "0:00";
          el.style.background = "#E85D3E";
          state.expiryTimeout = setTimeout(function () {
            state.expiryTimeout = null;
            stopHoldTimer();
            state.ref = null;
            state.expiresAt = null;
            setBookButtonState(
              true,
              "Your hold has expired. Please re-select a date.",
            );
            notifyUnavailable(
              "Your " +
                DEFAULT_TTL_MIN +
                "-minute hold has expired. Please re-select a date to continue.",
            );
          }, 1200);
          return;
        }

        valEl.textContent = formatRemaining(remaining);
        el.style.background = remaining <= 60000 ? "#E85D3E" : "#1E3A2F";
      }

      tick();
      if (state.timerInterval) clearInterval(state.timerInterval);
      state.timerInterval = setInterval(tick, 1000);
    }

    // ── run ─────────────────────────────────────────────────
    startInitialHold();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();